import React from "react";

const EyeOpen = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
    >
      <path
        d="M0.708496 6.49998C0.708496 6.49998 3.54183 0.833313 8.50016 0.833313C13.4585 0.833313 16.2918 6.49998 16.2918 6.49998C16.2918 6.49998 13.4585 12.1666 8.50016 12.1666C3.54183 12.1666 0.708496 6.49998 0.708496 6.49998Z"
        stroke="#EA6B3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 8.625C9.6736 8.625 10.625 7.6736 10.625 6.5C10.625 5.32639 9.6736 4.375 8.5 4.375C7.32639 4.375 6.375 5.32639 6.375 6.5C6.375 7.6736 7.32639 8.625 8.5 8.625Z"
        stroke="#EA6B3D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EyeOpen;
